export const clickForMoreLabel = "AMhQad";
export default {clickForMoreLabel};